import React, { useContext, useEffect, useState } from "react";
import FlooringNotificationBar from "./NotificationBar";
import FlooringNotificationContent from "./Notifications";
import axios from "../../axios/axios";
import { useDispatch, useSelector } from "react-redux";
import PageLoader from "../../components/PageLoader";
import {
    setAdminNotificationCount,
    setNotificationFilter,
} from "../../redux/slice/adminNotificationSlice";
import { useNavigate } from "react-router-dom";
import { NotificationContext } from "../DashboardLayout";
import { AuthenticationContext } from "../../App";
import { toast } from "react-toastify";
import { CommomPermission } from "../../common/Constants";
import LoaderImage from "../../images/ohhto-loading.gif";


const AddPropertyToArray = (data) => {
    return data.map((item) => ({
        ...item,
        label: item?.name,
        key: item?.id,
    }));
};

const FlooringNotificationLayout = () => {
    const accessToken = localStorage.getItem("agentModuleToken");
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { authData, setNotificationCount, setFlooringCount } = useContext(NotificationContext);
    const FlooringPErmission = authData?.permissions?.filter((it) => it.name === "flooring")?.map((itx) => itx?.submodules).flat()?.filter((its) => its?.name === "flooring-cases");
    const FloorPagePErmission = FlooringPErmission !== undefined && FlooringPErmission?.length > 0 ? FlooringPErmission[0] : CommomPermission;
    const filters = useSelector(
        (state) => state?.adminNotificationFilter?.notificationFilter
    );
    const settings = useSelector((state) => state.settings);
    const [loading, setLoading] = useState(false);
    const [adminNotifications, setAminNotifications] = useState([]);
    const [totalAdminNotifications, setTotalAdminNotifications] = useState([]);
    const [selectedNotification, setSelectedNotification] = useState({});
    const [selectedNotifications, setSelectedNotifications] = useState([]);
    const [selecAll, setSelecAll] = useState(false);

    const [notificationTabs, setNotificationsTab] = useState([
        { label: "All", key: "" },
        { label: "COE", key: "COE" },
        { label: "PARF", key: "PARF" },
        { label: "BODY ONLY", key: "BODYONLY" },
    ]);
    const [notfBar, setNotfBar] = useState(false);
    const [applyFilters, setApplyFilters] = useState(
        Object.keys(filters)?.length > 0
            ? filters
            : {
                search_key: "",
                productType: "",
                sortBy: "31",
            }
    );
    const [activeTab, setActiveTab] = useState({});

    const GetAdminNotifications = async (from) => {
        setLoading(true);
        const { data } = await axios.get(
            `/flooring/notifications?search_key=${applyFilters?.search_key !== undefined ? applyFilters?.search_key : ""
            }
      &sortOrder=${applyFilters?.sortBy}
      &vehicle_type=${applyFilters?.productType}`,
            applyFilters,
            {
                headers: {
                    Authorization: `Bearer ${accessToken}`,
                },
            }
        );
        if (data?.resp_code < 400) {
            const temp = data?.data?.notification;
            setAminNotifications(Object.values(temp).flat());
            setTotalAdminNotifications(Object.values(temp).flat());
            setLoading(false);
            if (from !== "select") {
                setInitialNotification(Object.values(temp).flat());
            }
        }

    };


    const OnNotifcationRead = async (type, groupby, from) => {
        let res = await axios.post(
            `flooring/notifications/markRead/${type === "unread" ? 0 : 1}`,
            {
                notification_ids: groupby,
            },
            {
                headers: {
                    Authorization: `Bearer ${accessToken}`,
                },
            }
        );
        if (res?.status < 400) {
            GetAdminNotifications(from);
            toast.success(res.data?.message);

        }
    };
    const setInitialNotification = (adminNotification) => {
        if (adminNotification?.length > 0) {
            const temp = adminNotification?.filter(
                (it) => it?.notification_type !== "application"
            );
            if (adminNotification[0]?.notification_type === "application") {
                let unReadNotification = adminNotification?.filter(
                    (it) => it?.read_at === null
                )?.length;
                setFlooringCount(unReadNotification);

            } else {
                let unReadNotification = adminNotification
                    ?.filter((id, index) => index !== 0)
                    ?.filter((it) => it?.read_at === null)?.length;
                setFlooringCount(unReadNotification);

            }
            if (temp?.length > 0) {
                console.log("TEMP", temp);
                setSelectedNotification(temp[0]);
                const newState = adminNotification.map((obj) => {
                    if (obj.index === temp[0]?.index) {
                        return { ...obj, status: 1 };
                    }
                    return obj;
                });
                setAminNotifications(newState);
                if (temp[0]?.read_at === null) {
                    OnNotifcationRead("read", [temp[0]?.id], "initial");
                }
            }
        } else {
            setFlooringCount(0);

        }
    };


    const onSearch = (key) => {
        let temp = totalAdminNotifications.filter((item) => {
            return item?.data?.name?.toLowerCase()?.includes(key?.toLowerCase());
        });

        if (temp !== undefined && temp !== null) {
            setAminNotifications(temp);
        }
    };
    const OnNotificationSelecct = (id) => {
        let temp = adminNotifications?.filter((it) => it?.id == id);
        const newState = adminNotifications.map((obj) => {
            if (obj.index === id) {
                return { ...obj, status: 1 };
            }
            return obj;
        });
        setAminNotifications(newState);
        setFlooringCount(newState?.filter((it) => it?.read_at === null)?.length);
        if (temp?.length > 0 && temp[0]?.notification_type !== "application") {
            setSelectedNotification(temp[0]);
            temp[0]?.read_at == null && OnNotifcationRead("read", [temp[0]?.id], "select");
        } else {
            temp[0]?.read_at == null && OnNotifcationRead("read", [temp[0]?.id], "select");
            setTimeout(() => {
                navigate("/case-detail", { state: { Id: temp[0]?.id } });
            }, 500);
        }
    };

    const MarkNotificationRead = async (type, selectedIDs) => {
        console.log("PROPS", type, selectedIDs);
        if (type === "ALLRead" || type === "ALLUnread") {
            const resp = await axios.post(`flooring/notifications/markRead/${type === "ALLUnread" ? 0 : 1}/ALL`, {
                notification_ids: selectedIDs,
            });
            if (resp.status < 400) {
                toast.success(resp.data?.message);
                GetAdminNotifications();
                setSelectedNotifications([]);
                setSelecAll(false);
            }
        } else {
            const resp = await axios.post(`flooring/notifications/markRead/${type === "unread" ? 0 : 1}`, {
                notification_ids: selectedIDs,
            });
            if (resp.status < 400) {
                toast.success(resp.data?.message);
                GetAdminNotifications();
                setSelectedNotifications([]);
                setSelecAll(false);
            }
        }
    };

    const onFilterRead = (type, selectedIds) => {
        MarkNotificationRead(type, selectedIds);
    };

    const onFilterChange = (type, value) => {
        setApplyFilters({
            ...applyFilters,
            [type]: value,
        });
        dispatch(
            setNotificationFilter({
                ...applyFilters,
                [type]: value,
            })
        );
    };

    useEffect(() => {
        if (settings?.loanProviderTypes?.length > 0) {
            // setNotificationsTab(AddPropertyToArray(settings?.loanProviderTypes));
        }
    }, [settings]);

    useEffect(() => {
        const unreadFlooringNotification = adminNotifications?.filter((it) => it?.read_at === null || it?.readt_at === "")

        setFlooringCount(unreadFlooringNotification?.length);
    }, [adminNotifications]);

    useEffect(() => {
        GetAdminNotifications();
    }, [applyFilters]);

    return (
        <div className="flex w-full">
            {loading && (
                <div className="absolute z-50 left-0 top-0 w-full h-full  flex items-center justify-center">
                    <img src={LoaderImage} className="w-24 h-24" />
                </div>
            )}
            <FlooringNotificationBar
                adminNotifications={adminNotifications}
                OnNotificationSelecct={OnNotificationSelecct}
                notificationTabs={notificationTabs}
                onFilterChange={onFilterChange}
                onSearch={onSearch}
                loading={loading}
                selectedNotification={selectedNotification}
                applyFilters={applyFilters}
                reload={GetAdminNotifications}
                notfBar={notfBar}
                notfBarClose={() => setNotfBar(false)}
                onFilterRead={onFilterRead}
                selectedNotifications={selectedNotifications}
                setSelectedNotifications={setSelectedNotifications}
                selecAll={selecAll}
                setSelecAll={setSelecAll}
            />
            <FlooringNotificationContent
                selectedNotification={selectedNotification}
                activeTab={activeTab}
                setActiveTab={setActiveTab}
                notfBar={() => setNotfBar(true)}
            />
        </div>
    );
};

export default FlooringNotificationLayout;
